import React from "react"
import ReactDOM from "react-dom/client"
import App from "./App"
import * as serviceWorker from "./serviceWorker"
import { BrowserRouter } from "react-router-dom"
import "./i18n"
import { Provider } from "react-redux"

// Registers global axios/fetch interceptors that drive the loader overlay -
// imported for its side effects, before anything can make a request.
import "./utils/axiosLoader"
import "./utils/fetchLoader"

import { PersistGate } from "redux-persist/integration/react"
import { store, persistor } from "./store"

const root = ReactDOM.createRoot(document.getElementById("root"))

root.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <>
        <BrowserRouter basename={process.env.PUBLIC_URL}>
          <App />
        </BrowserRouter>
      </>
    </PersistGate>
  </Provider>,
)

serviceWorker.unregister()
